import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = {
  class: "form-wrapper slide-up",
  style: {"width":"600px"}
}
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "pg-modal-title" }
const _hoisted_5 = { class: "pg-chips" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "pg-row" }
const _hoisted_8 = { class: "pg-seg" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 1,
  class: "pg-number-row"
}
const _hoisted_13 = {
  key: 2,
  class: "pg-hint",
  style: {"margin":"8px 0 0"}
}
const _hoisted_14 = { class: "pg-seg" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  class: "pg-hint",
  style: {"margin":"8px 0 0"}
}
const _hoisted_17 = { class: "pg-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.goal ? 'Personal Goal' : 'New Personal Goal'), 1),
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "pg-label" }, "Goal", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Name) = $event)),
        placeholder: "e.g. Finish my CPA, coach my son's team, pay off the truck",
        ref: "nameInput"
      }, null, 512), [
        [_vModelText, _ctx.form.Name]
      ]),
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "pg-label" }, "Kind of Goal", -1)),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (c) => {
          return (_openBlock(), _createElementBlock("button", {
            key: c.value,
            type: "button",
            class: _normalizeClass(["pg-chip", _ctx.form.Category == c.value ? 'on' : '']),
            onClick: ($event: any) => (_ctx.form.Category = c.value)
          }, _toDisplayString(c.label), 11, _hoisted_6))
        }), 128))
      ]),
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "pg-label" }, [
        _createTextVNode("Why It Matters "),
        _createElementVNode("span", { class: "pg-hint" }, "(optional)")
      ], -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Why) = $event)),
        placeholder: "One line you'll read when it gets hard"
      }, null, 512), [
        [_vModelText, _ctx.form.Why]
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "pg-label" }, "Done By", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.DueDate) = $event))
          }, null, 512), [
            [_vModelText, _ctx.form.DueDate]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "pg-label" }, "How You'll Track It", -1)),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trackTypes, (t) => {
              return (_openBlock(), _createElementBlock("button", {
                key: t.value,
                type: "button",
                class: _normalizeClass(_ctx.form.TrackType == t.value ? 'on' : ''),
                onClick: ($event: any) => (_ctx.setTrackType(t.value))
              }, _toDisplayString(t.label), 11, _hoisted_9))
            }), 128))
          ])
        ])
      ]),
      (_ctx.form.TrackType == 'steps')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Steps, (s, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "pg-step-row"
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": ($event: any) => ((s.Text) = $event),
                  placeholder: 'Step ' + (i + 1),
                  ref_for: true,
                  ref: 'step' + i,
                  onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (_ctx.addStep()), ["prevent"]), ["enter"]))
                }, null, 40, _hoisted_10), [
                  [_vModelText, s.Text]
                ]),
                _createElementVNode("span", {
                  class: "pg-x",
                  title: "Remove step",
                  onClick: ($event: any) => (_ctx.form.Steps.splice(i, 1))
                }, [
                  _createVNode(_component_svg_icon, { icon: "x" })
                ], 8, _hoisted_11)
              ]))
            }), 128)),
            _createElementVNode("div", {
              class: "pg-add-step",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addStep()))
            }, "+ Add Step")
          ], 64))
        : (_ctx.form.TrackType == 'number')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _cache[16] || (_cache[16] = _createElementVNode("span", null, "From", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.StartValue) = $event)),
                "aria-label": "Start"
              }, null, 512), [
                [_vModelText, _ctx.form.StartValue]
              ]),
              _cache[17] || (_cache[17] = _createElementVNode("span", null, "to", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.TargetValue) = $event)),
                placeholder: "12",
                "aria-label": "Target"
              }, null, 512), [
                [_vModelText, _ctx.form.TargetValue]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.Unit) = $event)),
                placeholder: "books, lbs, $…",
                "aria-label": "Unit",
                class: "pg-unit"
              }, null, 512), [
                [_vModelText, _ctx.form.Unit]
              ])
            ]))
          : _createCommentVNode("", true),
      (_ctx.goal && _ctx.form.TrackType != _ctx.goal.TrackType)
        ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Changing how it's tracked starts its progress over."))
        : _createCommentVNode("", true),
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "pg-label" }, "Who Can See It", -1)),
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibilities, (v) => {
          return (_openBlock(), _createElementBlock("button", {
            key: v.value,
            type: "button",
            class: _normalizeClass(_ctx.form.Visibility == v.value ? 'on' : ''),
            onClick: ($event: any) => (_ctx.form.Visibility = v.value)
          }, _toDisplayString(v.label), 11, _hoisted_15))
        }), 128))
      ]),
      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.visibilityHint), 1),
      _createElementVNode("div", _hoisted_17, [
        (_ctx.goal)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "pg-danger",
              onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.showConfirmDelete = true), ["prevent"]))
            }, "Delete"))
          : _createCommentVNode("", true),
        _cache[18] || (_cache[18] = _createElementVNode("span", { style: {"flex":"1"} }, null, -1)),
        _createElementVNode("div", {
          class: "btn-light",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('close')))
        }, "Cancel"),
        _createElementVNode("div", {
          class: _normalizeClass(["btn", _ctx.saving ? 'disable-button' : '']),
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.save()))
        }, _toDisplayString(_ctx.goal ? 'Save' : 'Add Goal'), 3)
      ])
    ]),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 0,
          onConfirm: _cache[12] || (_cache[12] = ($event: any) => (_ctx.remove())),
          onCancel: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showConfirmDelete = false)),
          msg: "Delete this goal and its check-ins?"
        }))
      : _createCommentVNode("", true)
  ]))
}